// API地址配置工具

// 调试: 查看环境变量是否正确加载
console.log('API环境变量:', process.env.VUE_APP_API_URL || '未设置');

/**
 * 处理URL，将相对路径转换为完整路径
 * 如果VUE_APP_API_URL环境变量存在，使用它作为API前缀
 * 否则，使用相对路径（配合Nginx反向代理使用）
 * @param {string} url - 相对路径URL
 * @returns {string} - 完整的API URL
 */
export const getApiUrl = (url) => {
  // 如果是完整URL，直接返回
  if (url.startsWith('http')) {
    return url;
  }

  // 确保url以/开头
  const path = url.startsWith('/') ? url : `/${url}`;
  
  // 强制使用正确的API基础URL (开发环境)
  // 生产环境下，此值将为空，使用相对路径
  const apiBaseUrl = process.env.VUE_APP_API_URL || 'http://localhost:8081';
  
  return `${apiBaseUrl}${path}`;
};

/**
 * 获取资源的完整URL
 * 主要用于图片等资源的URL转换
 * @param {string} url - 资源URL或路径
 * @returns {string} - 完整的资源URL
 */
export const getResourceUrl = (url) => {
  // 如果已经是完整URL，直接返回
  if (url.startsWith('http')) {
    return url;
  }

  // 确保url以/开头
  const path = url.startsWith('/') ? url : `/${url}`;
  
  // 强制使用正确的API基础URL (开发环境)
  // 生产环境下，此值将为空，使用相对路径
  const apiBaseUrl = process.env.VUE_APP_API_URL || 'http://localhost:8081';
  
  return `${apiBaseUrl}${path}`;
}; 